import commaSeparatedIPsCIDR from 'app/forms/validations/commaSeparatedIPsCIDR.js';

function removeNetclassAndComma(input) {
  // Use regex to match optional comma followed by "netclass" and remove them
  if (!input || typeof input !== 'string') {
    return '';
  }
  return input.replace(/(netclass),?/g, '');
}

export default {
  message: 'This field requires one or more comma-separated IP addresses and/or the term "netclass"',
  fn: (value) => {
    const remaining = removeNetclassAndComma(value);
    const normalized = remaining.replace(/\s+/g, '');

    return commaSeparatedIPsCIDR.fn(remaining) || normalized === '';
  }
};
